export interface FullscreenElement extends HTMLElement{
    mozRequestFullScreen(): Promise<void>;
    webkitRequestFullscreen(): Promise<void>;
    msRequestFullscreen(): Promise<void>;
}

export interface FullscreenDocument extends Document {
    webkitFullscreenElement: Element | null;
    mozFullScreenElement: Element | null;
    msFullscreenElement: Element | null;
    mozCancelFullScreen(): Promise<void>;
    webkitExitFullscreen(): Promise<void>;
    msExitFullscreen(): Promise<void>;
}

export function isFullscreen(document: FullscreenDocument) {
    return Boolean(
        document.webkitFullscreenElement
        || document.mozFullScreenElement
        || document.msFullscreenElement
        || document.fullscreenElement,
    );
}

export function toggleFullscreen(document: Document, element: HTMLElement) {
    if (isFullscreen(document as FullscreenDocument)) {
        exitFullscreen(document as FullscreenDocument);
    } else {
        enterFullscreen(element as FullscreenElement);
    }
}

export function enterFullscreen(fullscreenElement: FullscreenElement) {
    if (fullscreenElement.requestFullscreen) {
        fullscreenElement.requestFullscreen();
    } else if (fullscreenElement.mozRequestFullScreen) { /* Firefox */
        fullscreenElement.mozRequestFullScreen();
    } else if (fullscreenElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        fullscreenElement.webkitRequestFullscreen();
    } else if (fullscreenElement.msRequestFullscreen) { /* IE/Edge */
        fullscreenElement.msRequestFullscreen();
    }
}

export function exitFullscreen(fullscreenDocument: FullscreenDocument) {
    // If the method happens to be called twice, just return
    if (!isFullscreen(fullscreenDocument)) {
        return;
    }
    
    if (fullscreenDocument.exitFullscreen) {
        fullscreenDocument.exitFullscreen();
    } else if (fullscreenDocument.mozCancelFullScreen) { /* Firefox */
        fullscreenDocument.mozCancelFullScreen();
    } else if (fullscreenDocument.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        fullscreenDocument.webkitExitFullscreen();
    } else if (fullscreenDocument.msExitFullscreen) { /* IE/Edge */
        fullscreenDocument.msExitFullscreen();
    }
}
